<template lang="pug">
.study-result-detail-list
  //- サイドメニュー部
  side-menu.study-result-detail-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .study-result-detail-list__content
    breadcrumb-list.study-result-detail-list__content__breadcrumb(
      :breadcrumbs='breadcrumbs',
      :moveEvent='breadcrumbMoveEvent'
    )
    //- 得点情報一覧表示
    .study-result-detail-list__content__body
      .study-result-detail-list__content__body__heading
        tab-heading.study-result-detail-list__content__body__heading__tab(:isActive='true') {{ titleText }}
      .study-result-detail-list__content__body__main-top
        study-result-detail-score-table.study-result-detail-list__content__body__main-top__table(
          :studyResultDetailScore='studyResultDetailScore',
        )
          template(#totalScoreHeader)
            slot(name='totalScoreHeader')
          template(#knowledgeScoreHeader)
            slot(name='knowledgeScoreHeader')
          template(#thinkingScoreHeader)
            slot(name='thinkingScoreHeader')
          template(#scoreLabel)
            slot(name='scoreLabel')
          template(#averageLabel)
            slot(name='averageLabel')
    //- 詳細一覧表示
    .study-result-detail-list__content__body
      .study-result-detail-list__content__body__main
        study-result-detail-table.study-result-detail-list__content__body__main__table(
          :studyResultDetails='studyResultDetails'
        )
          template(#problemNumberHeader)
            slot(name='problemNumberHeader')
          template(#questionNumberHeader)
            slot(name='questionNumberHeader')
          template(#correctSymbolHeader)
            slot(name='correctSymbolHeader')
          template(#correctRateHeader)
            slot(name='correctRateHeader')
    //- アドバイスメッセージ
    .study-result-detail-list__content__body
      .study-result-detail-list__content__body__main
        .study-result-detail-list__content__body__main__advice
          .study-result-detail-list__content__body__main__advice__message.text-small
            .study-result-detail-list__content__body__main__advice__message__title.font-bold
              slot(name='studyAdviceTitle')
            .study-result-detail-list__content__body__main__advice__message__text(v-html='studyAdviceMessage')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import StudyResultDetailTable from '@/components/organisms/manager/StudyResultDetailTable.vue'
import StudyResultDetailScoreTable from '@/components/organisms/manager/StudyResultDetailScoreTable.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { StudyResultDetailType, StudyResultDetailScore } from '@/models/studyResultDetailModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'

/**
 * 履歴管理・生徒の成績表詳細画面
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    StudyResultDetailTable,
    StudyResultDetailScoreTable,
  },
})
export default class StudyResultDetailList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // パンくず遷移イベント
  @Prop()
  breadcrumbMoveEvent!: Function

  // タブに表示するタイトル
  @Prop()
  titleText!: string

  // テスト結果詳細得点情報
  @Prop()
  studyResultDetailScore!: StudyResultDetailScore

  // テスト結果詳細表示情報
  @Prop()
  studyResultDetails!: StudyResultDetailType[]

  // 学習アドバイスメッセージ
  @Prop()
  studyAdviceMessage!: string
}
</script>

<style lang="stylus" scoped>
.study-result-detail-list
  display flex
  width 100%
  height 100%

  &__content
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 20px
    overflow-y auto

    &__body
      display flex
      flex-direction column

      &__heading
        display flex
        height 43px

      &__main
        border-radius 15px

      &__main-top
        border-radius 0px 15px 15px 15px

      &__main,
      &__main-top
        z-index 1
        width 100%
        display flex
        flex-direction column
        background var(--color-manager-list__background)
        box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)

        &__table
          margin 20px 0 40px 0

        &__advice
          padding 12px 20px

          &__message
            border 1px solid var(--color-manager-list__border)
            border-radius 10px
            padding 12px

            &__title
              color var(--color-manager-list-alert__text)

            &__text
              padding 10px 20px
              white-space break-spaces
</style>
